import { Components, ComponentsProps } from "@thisgorilla/primate-ds";
import styled from "styled-components";
import { API_PATHS } from "../../../API/api_paths";
import { useAppSelector } from "../../../redux";
import AnonymousUserToolTip from "../AnonymousUserToolTip";
import { FlexColumn } from "../Styles";
import { AnonymousUserListProps } from "./AnonymousUserList";

const AnonymousUserList = ({
  selectedOption,
  setSelectedOption,
}: AnonymousUserListProps.IProps) => {
  const { anonymous_persona, first_name, last_name, profile_picture } =
    useAppSelector((state) => state.me);
  const userName = first_name + " " + last_name;

  const onClick = (
    option: ComponentsProps.ListItemProps.DefaultListItemProps
  ) => {
    setSelectedOption(option.label);
  };

  return (
    <Wrapper
      $anonymousSelected={selectedOption === anonymous_persona}
      $userSelected={selectedOption === userName}
    >
      <Components.ListItem
        type="List Item"
        label={userName}
        disabled={false}
        radio={true}
        avatarSrc={profile_picture}
        avatarType="Circle"
        onClick={onClick}
        renderInSingleLine={true}
        selected={selectedOption === userName}
      />
      <ItemContainer $anonymousSelected={selectedOption === anonymous_persona}>
        <Components.ListItem
          type="List Item"
          label={anonymous_persona}
          disabled={false}
          radio={true}
          avatarSrc={API_PATHS.global.anonymous_persona + "anon_1.svg"}
          avatarType="Circle"
          selected={selectedOption === anonymous_persona}
          onClick={onClick}
          renderInSingleLine={true}
          ArrowIconType="Info"
          ArrowIconToolTip={<AnonymousUserToolTip />}
        />
      </ItemContainer>
    </Wrapper>
  );
};

export default AnonymousUserList;

const Wrapper = styled(FlexColumn)<{
  $anonymousSelected: boolean;
  $userSelected: boolean;
}>`
  & > .list-item label {
    color: ${({ theme, $userSelected }) =>
      $userSelected
        ? theme.Color.text["text-primary"].value
        : theme.Color.text["text-tertiary"].value};
  }

  .tootltip-children > button svg path {
    stroke: ${({ theme, $anonymousSelected }) =>
      theme.Color.icon[
        $anonymousSelected ? "icon-brand-bolder" : "icon-tertiary"
      ].value};
  }
`;

const ItemContainer = styled.div<{ $anonymousSelected: boolean }>`
  position: relative;
  padding-left: ${({ theme }) => theme.spacing["spacing-7"].value}rem;

  &:before {
    content: "";
    position: absolute;
    left: 15px;
    top: ${({ theme }) => theme.spacing["spacing-none"].value}rem;
    width: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
    height: calc(100% - 14px);
    border-left: 1px solid
      ${({ theme, $anonymousSelected }) =>
        $anonymousSelected
          ? theme.Color.border.brand.default.value
          : theme.Color.border["ui-border-neutral"].value};
    border-bottom-left-radius: ${({ theme }) =>
      theme.radius["radius-xxxs"].value}rem;
  }

  & .list-item {
    position: relative;
    &:before {
      content: "";
      position: absolute;
      left: -14px;
      top: ${({ theme }) => theme.spacing["spacing-none"].value}rem;
      width: 14px;
      height: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
      border-bottom: 1px solid
        ${({ theme, $anonymousSelected }) =>
          $anonymousSelected
            ? theme.Color.border.brand.default.value
            : theme.Color.border["ui-border-neutral"].value};
      border-bottom-left-radius: ${({ theme }) =>
        theme.radius["radius-xxxs"].value}rem;
    }
    & label {
      color: ${({ theme, $anonymousSelected }) =>
        $anonymousSelected
          ? theme.Color.text["text-primary"].value
          : theme.Color.text["text-tertiary"].value};
    }
  }
`;
